export default "./images/survio-14VQG-fonts-icomoon.svg";